
<script>

import gsap from "gsap"

export default {

  name: 'ShareComp',
  render: h => h(),
  props:['indice'],
  data: ()=>({
    city: 'Unknown',
    country: 'Unknown'
  }),
  computed: {
    status() { return this.$store.getters['app/status'] }
  },
  watch: {
    status(nw) {
      if(nw == 'sharing') 
        this.submit()
    }
  },

  mounted() {
    if (navigator.geolocation) 
      navigator.geolocation.getCurrentPosition(this.successFunction, this.errorFunction)
  },

  methods: { 

    successFunction(position) {

      var lat = position.coords.latitude
      var lng = position.coords.longitude

      // console.log(lat, lng);  

      let bdcApi = "https://api.bigdatacloud.net/data/reverse-geocode-client"
          bdcApi = bdcApi
          + "?latitude=" + position.coords.latitude
          + "&longitude=" + position.coords.longitude
          + "&localityLanguage=en";

      // console.log(bdcApi);

      this.axios({
            method: 'get',
            url: bdcApi,  
          })
          .then((res)=> {
            
            // console.log(res);

            this.city = res.data.city
            this.country = res.data.countryName
  
          })
    },

    errorFunction(){
      console.log("Geocoder failed");
    },

    blobToBase64(blob) {  
      return new Promise(res => {    
        const reader = new FileReader()
              reader.readAsDataURL(blob)
              reader.onload = () => res(reader.result)
      })
    },

    submit: async function() {   
      const formData = new FormData();
      if(this.indice == 'words'){
        formData.append('plaintext', this.$parent.$refs.textarea.value)
      }
      else {
        const base64 = await this.blobToBase64(this.$parent.$blob)
        formData.append('audio', base64.split(";base64,")[1])
      } 

      formData.append('location_country', this.country)
      formData.append('location_city',  this.city)

      this.axios({
            method: 'post',
            url: 'https://api.wbloomdev.com/api/post/ugc',
            data: formData,
            headers: {  
              'api-key': 'J7LTPxyAhqEXxkuqF7aJRA', 
              'Content-Type': 'multipart/form-data' }
          })
          .then((res)=> {
            console.log(res);
            this.$router.push({ params: { section: 'finish', step: undefined } })
          })
    },

  }

}
</script>


